import './TeamScoreboard.css';
import TimingClock from '../../components/TimingClock';
import {
  liftsSelector,
  teamsSelector,
  athletesSelector,
} from '../../orm/selectors';

import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
//import { createSelector } from 'reselect';
import {
  find,
  //findIndex,
  filter,
  //flatMap,
  //get,
  map,
  //maxBy,
  pick,
  //range,
  sumBy,
  //uniq,
} from 'lodash';

const TeamScoreboardHeader = ({ meta }) => (
  <Fragment>
    <colgroup>
      <col class="team column" />
      <col class="points column" />
      <col class="rank column" />
    </colgroup>
    <thead>
      <tr>
        <th>TEAM</th>
        <th>POINTS</th>
        <th>RANK</th>
      </tr>
    </thead>
  </Fragment>
);

const TeamScoreboardRow = ({ row, meta }) => {
  return (
    <tr className="team row">
      <td className="name cell">{row.name}</td>
      <td className="points cell">{row.points.toFixed(3)}</td>
      <td className="rank cell">{row.rank}</td>
    </tr>
  );
};

class TeamScoreboard extends Component {
  state = { blink: false };

  blink = () => {
    this.setState(state => ({ blink: !state.blink }));
  };

  componentDidMount() {
    this.blinkInterval = window.setInterval(this.blink, 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.blinkInterval);
  }

  render() {
    const { rows, timingClock, orm } = this.props;
    const meta = { orm };
    const { blink } = this.state;
    const className = blink ? 'blink' : '';
    return (
      <main className="nosturi team-scoreboard page">
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            marginRight: '2rem',
            marginTop: '2rem',
          }}
        >
          <TimingClock {...timingClock} size="big" />
        </div>
        <h1>Team Scoreboard</h1>
        <table className={`nosturi team-scoreboard table ${className}`}>
          <TeamScoreboardHeader meta={meta} />
          <tbody>
            {map(rows, row => (
              <TeamScoreboardRow key={row.key} row={row} meta={meta} />
            ))}
          </tbody>
        </table>
      </main>
    );
  }
}

TeamScoreboard.slug = 'team-scoreboard';
TeamScoreboard.title = 'Team Scoreboard';

const mapStateToProps = ({ venue, orm }) => {
  const lifts = liftsSelector(orm);
  const teams = teamsSelector(orm);
  const athletes = athletesSelector(orm);

  const rows = map(teams, team => ({
    key: team.uuid,
    ...pick(team, 'name'),
    points:
      Math.round(
        sumBy(athletes, athlete => {
          if (!find(athlete.entry.teams, pick(team, 'uuid'))) return 0;

          const { weighInDatum } = athlete.entry;
          if (!weighInDatum) return 0;

          const A = 0.75194503;
          const b = 175.508;

          const x = weighInDatum.bodyweight;
          const X = Math.log10(x / b);

          const SC = x <= b ? Math.pow(10, A * Math.pow(X, 2)) : 1;

          const total = sumBy(
            Object.values(athlete.bestAttemptByLiftId),
            'weight',
          ) || 0;
          return SC * total;
        }) * 1000,
      ) / 1000,
  }));

  const rowsWithRanks = map(rows, row => ({
    ...row,
    rank: filter(rows, ({ points }) => points > row.points).length + 1,
  }));

  return {
    rows: rowsWithRanks,
    ...pick(venue.competition, 'timingClock'),
    orm: {
      lifts,
      teams,
      //protocols,
    },
  };
};

export default connect(mapStateToProps)(TeamScoreboard);



// WEBPACK FOOTER //
// ./src/displays/TeamScoreboard/TeamScoreboard.js